import { registerComponent } from '@gig/magic-common';
import SelfExcludeComponent from './self-exclude.vue.js';

var SelfExclude = registerComponent(SelfExcludeComponent);

export { SelfExclude };
